export const canvas = document.getElementById("canvas");
export const ctx = canvas.getContext("2d");

const road = new Image();
road.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_30,w_700/v1518732858/roadl1_y3sfxq.jpg';
const site = new Image();
site.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_40,w_700/v1518732913/construction_zseail.jpg';
const grass = new Image();
grass.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_700/v1518732957/grass_clz8n2.jpg';
const lava = new Image();
lava.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_700/v1518732993/lava_nssgil.png';
const purp = new Image();
purp.src = 'https://i.ytimg.com/vi/vFPWVCbDqTc/maxresdefault.jpg';
const explosion = new Image();
explosion.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_500/v1518733078/explosion_wceexm.png';


export default class Board {

  drawRoad() {
    ctx.drawImage(road, 21, 400, 700, 400);
  }

  drawSite() {
    ctx.drawImage(site, 21, 21, 700 , 300);
  }

  drawGrass() {
    ctx.drawImage(grass, 21, 321, 700, 78.5);
  }

  drawLava() {
    ctx.drawImage(lava, 21, 21, 700, 700);
  }

  drawPurp() {
    ctx.drawImage(purp, 21,21,698,698);
  }

  drawExplosion() {
    ctx.drawImage(explosion, 200, -25, 350, 350);
  }
}



// WEBPACK FOOTER //
// ./lib/board.js